'use client';

import { Check } from '@energy-retailer/icons';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { Text } from '@/components/text';

const PlanFlowStep = ({
  id,
  labelHeader,
  labelSubHeader,
  isActive,
  onClick,
  stepNumber,
  disabled = false,
}: {
  id: string;
  onClick: (() => void) | undefined;
  labelHeader?: string;
  labelSubHeader?: string | null;
  isActive: boolean;
  stepNumber: number;
  disabled?: boolean;
}) => {
  return (
    <button
      id={id}
      type="button"
      className="group flex gap-a"
      onClick={onClick}
      disabled={disabled}
      aria-label={`${labelHeader ?? 'choice'} step button`}
    >
      <div className={clsx([isActive ? "bg-pink-500" : "bg-gray-400", labelSubHeader && "!bg-[#39825b]", "flex h-icon-xs w-icon-xs items-center justify-center rounded-full p-4 text-center text-white group-disabled:bg-gray-400"])}>
        {labelSubHeader ? (
          <div className="w-icon-xs">
            <Check />
          </div>
        ) : (
          <Text variant="h4">{stepNumber}</Text>
        )}
      </div>
      <div className="flex flex-col">
        <Text
          variant="h3"
          className={twMerge(
            clsx('text-gray-700 group-disabled:text-gray-400 text-left text-md', {
              'underline': isActive, 'text-pink-500': isActive && !labelSubHeader
            })
          )}
        >
          {labelHeader}
        </Text>
        <Text
          variant="body2"
          className={twMerge(
            clsx('text-gray-700 text-left text-base font-light', { "italic": !labelSubHeader })
          )}
        >
          {labelSubHeader || 'Select plan'}
        </Text>
      </div>
    </button>
  );
};

export { PlanFlowStep };